import {Alert, Card, ConfigProvider, Skeleton, Spin} from 'antd';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';

import {RQGetOrderAPI, RQGetUserAPI, RqGetAllProducts} from '../../../reactQuery/apis';
import {selectAuth} from '../../../redux/selectors';

import {LowStockModal} from './LowStockModal';

const UserCountScreen = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const id = token ? JSON.parse(atob(token.split('.')[1]))?.userId : null;

  const {data: userData, isLoading, isError, error} = RQGetUserAPI(id, token);

  const userCount = Array.isArray(userData) ? userData.length : 0;

  const {
    data: allProducts = [],
    isLoading: isProductsLoading,
    isError: isProductError,
    error: productError,
  } = RqGetAllProducts(token);

  const {
    data: orderData,
    isLoading: isOrdersLoading,
  } = RQGetOrderAPI(id, token);

  const lowStockProducts = allProducts.filter(product =>
    product.size?.some(s => parseInt(s.quantity) <= 5),
  );

  const lowStockCount = lowStockProducts.length;

  if (isLoading || isProductsLoading) {
    return (
      <div className={'flex justify-center items-center h-screen bg-primary-100'}>
        <Spin size={'large'} />
      </div>
    );
  }

  if (isError || isProductError) {
    return (
      <Alert
        message={'Error'}
        description={error?.message || productError?.message || 'Failed to fetch data'}
        type={'error'}
        showIcon
      />
    );
  }
  const orderCount = Array.isArray(orderData) ? orderData.length : 0;
  const productCount = Array.isArray(allProducts) ? allProducts.length : 0;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#ffffff',
        },
      }}
    >
      <div className={'p-4  sm:p-6 md:p-8 bg-primary-100 text-black min-h-[80vh]'}>
        <div className={'flex w-full flex-wrap gap-8 justify-center text-center '}>

          {/* User Card */}
          <div className={'flex'}>
            <Link to={'/user'} className={'w-full sm:w-[280px] lg:w-[300px]'}>
              <Card
                variant={'borderless'}
                className={'bg-white/60 hover:bg-white/80 transition-all duration-300 h-40 border-none shadow-md rounded-2xl flex flex-col justify-center items-center text-black sm:w-[280px] lg:w-[300px]'}
              >
                <div className={'font-semibold text-center'}>
                  <p className={'text-lg p-1'}>Total Users:</p>
                  <p className={'text-3xl mt-2'}>
                    {isLoading ? (
                      <Skeleton.Input active size={'small'} style={{width: 60}} />
                    ) : (
                      userCount
                    )}
                  </p>
                </div>
              </Card>
            </Link>
          </div>

          {/* Total Orders */}
          <div>
            <Link to={'/order'} className={'w-full sm:w-[280px]'}>
              <Card
                variant={'borderless'}
                className={'bg-white/60 hover:bg-white/80 transition-all duration-300 h-40 border-none shadow-md rounded-2xl flex flex-col justify-center items-center text-black sm:w-[280px] lg:w-[300px]'}
              >
                <div className={'font-semibold text-center'}>
                  <p className={'text-lg p-1'}>Total Orders:</p>
                  <p className={'text-3xl mt-2'}>
                    {isOrdersLoading ? (
                      <Skeleton.Input active size={'small'} style={{width: 60}} />
                    ) : (
                      orderCount
                    )}
                  </p>
                </div>
              </Card>
            </Link>
          </div>

          {/* Total Products */}
          <div>
            <Link to={'/team/product'} className={'w-full sm:w-[280px]'}>
              <Card
                variant={'borderless'}
                className={'bg-white/60 hover:bg-white/80 transition-all duration-300 h-40 border-none shadow-md rounded-2xl flex flex-col justify-center items-center text-black sm:w-[280px] lg:w-[300px]'}
              >
                <div className={'font-semibold text-center'}>
                  <p className={'text-lg'}>Total Products:</p>
                  <p className={'text-3xl mt-2'}>
                    {isProductsLoading ? (
                      <Skeleton.Input active size={'small'} style={{width: 60}} />
                    ) : (
                      productCount
                    )}
                  </p>
                </div>
              </Card>
            </Link>
          </div>

          {/* Low Stock Card */}
          <div>
            <Card
              variant={'borderless'} 
              className={'bg-white/60 hover:bg-white/80 transition-all duration-300 h-40 border-none shadow-md rounded-2xl flex flex-col justify-center items-center cursor-pointer text-black w-full sm:w-[280px] lg:w-[300px]'}
              onClick={() => setIsModalOpen(true)}
            >
              <div className={'font-semibold text-center '}>
                <div className={'flex md:flex-row flex-col'}>
                  <p className={'text-lg md:mr-1'}> Low Products</p>
                  <p className={'text-lg'}> Stock:</p>
                </div>
                <p className={'text-3xl mt-2 underline decoration-[#ff0000]'}>
                  {isProductsLoading ? (
                    <Skeleton.Input active size={'small'} style={{width: 60}} />
                  ) : (
                    lowStockCount
                  )}
                </p>
              </div>
            </Card>
          </div>
        </div>

        <LowStockModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          lowStockProducts={lowStockProducts}
          isLoading={isProductsLoading}
        />
      </div>
    </ConfigProvider>
  );
};

export default UserCountScreen;
